import React from 'react';
import userContext from '../services/userContext'
import CircularProgress from 'material-ui/CircularProgress';
import Paper from 'material-ui/Paper';
import ProjectList from './projectList/ProjectList';

class Home extends React.Component {

    render() {
        let contentPanel;
        if (userContext.fetchingUser) {
            contentPanel = <CircularProgress className="activityIndicator"/>;
        } else if (userContext.isLoggedIn()) {
            contentPanel = <ProjectList />;
        } else {
            contentPanel = <Paper className="login-panel" zDepth={1} >Welcome, please login</Paper>;
        }
        return contentPanel;
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js